import React from "react";
import styles from "../../styles/login/welcome.module.css";
import welcome from "../../assets/images/welcomepng.png";
import icon from "../../assets/images/vajra.svg";
import { useNavigate } from "react-router-dom";
// import confetti from "canvas-confetti";

const Welcome = () => {
  const navigate = useNavigate();

  // const launchSubtleConfetti = () => {
  //   const colors = [
  //     "#FFD700", // gold
  //     "#FFFFFF", // white
  //     "#C0C0C0", // silver
  //     "#B0E0E6", // powder blue
  //     "#D8BFD8", // thistle/violet
  //     "#98FB98", // pale green
  //     "#FAD6A5", // champagne
  //     "#FFC0CB", // light pink
  //     "#ADD8E6", // light sky blue
  //     "#F5F5DC", // beige
  //     "#20B2AA", // light sea green
  //     // "#800080", // purple
  //     "#FF6347", // tomato red
  //   ];

  //   // Main burst
  //   confetti({
  //     particleCount: 800,
  //     spread: 180, // wider spread
  //     startVelocity: 50,
  //     origin: { y: 0.7 },
  //     colors,
  //     scalar: 1.2,
  //     ticks: 3000, // longer float time
  //   });

  //   // Soft side burst 1 (left)
  //   setTimeout(() => {
  //     confetti({
  //       particleCount: 400,
  //       angle: 60,
  //       spread: 120,
  //       startVelocity: 30,
  //       origin: { x: 0, y: 0.6 },
  //       colors,
  //       scalar: 1,
  //       ticks: 3000,
  //     });
  //   }, 300);

  //   // Soft side burst 2 (right)
  //   setTimeout(() => {
  //     confetti({
  //       particleCount: 300,
  //       angle: 120,
  //       spread: 120,
  //       startVelocity: 30,
  //       origin: { x: 1, y: 0.6 },
  //       colors,
  //       scalar: 1,
  //       ticks: 3000,
  //     });
  //   }, 600);
  // };

  return (
    <div className={styles.main_container}>
      <div className={styles.image_container}>
        <div>
          <div className={styles.icon_container}>
            <img src={icon} alt="VAJRA" className={styles.icon_image} />

            <div className={styles.text_container}>
              <p className={styles.icon_text}>VAJRA</p>
            </div>
          </div>

          <p className={styles.heading}>
            Your journey to <span>streamlined ESG</span> data management{" "}
            <span>begins </span>
            here.
          </p>
        </div>

        <img src={welcome} alt="welcome" className={styles.image} />
      </div>
      <div className={styles.redirection_container}>
        <p className={styles.redirect_heading}>WELCOME TO VAJRA !</p>
        <p className={styles.redirect_subheading}>
          Let’s make sustainability measurable, manageable, and meaningful.
        </p>
        <button
          className={styles.button}
          onClick={() => {
            // launchSubtleConfetti();
            navigate("/dashboard");
          }}
        >
          Continue to Dashboard
        </button>
      </div>
    </div>
  );
};

export default Welcome;
